import { createSelector } from 'reselect';

const list = state => state.users.list;
const selectedGuid = state => state.users.selectedGuid;

const selectedUser = createSelector(
  [list, selectedGuid],
  (users, userGuid) => {
    const selected = !users ? null : users.find(user => user.guid === userGuid);
    return !selected ? null : selected;
  },
);

export default { selectedUser };
